import Vue from "vue";
import Vuex from "vuex";

import profile from "./modules/profile.module";
import buy from "./modules/buy.module";
import bank from "./modules/bank.module";
import company from "./modules/company.module";
import auth from "./modules/auth.module";
import consignment from "./modules/consignment.module";
import admin from "./modules/admin.module";
import user from "./modules/user.module";
import report from "./modules/report.module";
import rol from "./modules/rol.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    profile,
    company,
    buy,
    bank,
    consignment,
    admin,
    user,
    report,
    rol
  }
});
